import { MapPin, Timer } from "lucide-react";
import { MapContainer, TileLayer, CircleMarker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { Reveal, MaskedLine } from "./Reveal";

const zones = [
  { zone: "Balneário Camboriú", time: "10–20 min", status: "Técnico próximo", hot: true },
  { zone: "Itajaí", time: "15–25 min", status: "Disponível", hot: false },
  { zone: "Camboriú", time: "15–25 min", status: "Disponível", hot: false },
  { zone: "Itapema", time: "20–30 min", status: "Disponível", hot: false },
];

const cityCoords = {
  "Balneário Camboriú": [-26.9906, -48.6356],
  "Itajaí": [-26.9078, -48.6619],
  "Camboriú": [-27.0247, -48.654],
  "Itapema": [-27.0903, -48.6114],
};

export default function Coverage() {
  return (
    <section id="cobertura" data-testid="coverage-section" className="relative py-24 sm:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
        <div>
          <Reveal>
            <p className="font-tech text-xs uppercase tracking-[0.25em] text-[#e8112d] font-semibold mb-4">
              Raio de cobertura
            </p>
          </Reveal>
          <h2 className="font-display font-extrabold uppercase tracking-tight leading-[1.05] text-4xl sm:text-5xl">
            <MaskedLine delay={0.1}>Onde você</MaskedLine>
            <MaskedLine delay={0.22}>
              <span className="text-[#e8112d] text-glow">parou,</span>
            </MaskedLine>
            <MaskedLine delay={0.34}>nós chegamos.</MaskedLine>
          </h2>
          <Reveal delay={0.2}>
            <p className="mt-6 text-sm sm:text-base text-slate-400 leading-relaxed max-w-md">
              Unidade móvel posicionada estrategicamente para cobrir todo o litoral norte de
              Santa Catarina. Tempo médio de chegada monitorado em tempo real.
            </p>
            <div className="mt-8 flex items-baseline gap-3">
              <span className="font-display font-extrabold text-6xl sm:text-7xl text-[#e8112d] text-glow">20</span>
              <span className="font-tech text-xs uppercase tracking-[0.22em] text-slate-500">
                minutos
                <br />
                tempo médio
              </span>
            </div>
          </Reveal>
        </div>

        <div className="flex flex-col gap-3">
          {zones.map((z, i) => (
            <Reveal key={z.zone} delay={i * 0.08}>
              <div
                data-testid={`coverage-zone-item-${i}`}
                className="card-metal metal-edge-top rounded-xl border border-white/5 hover:border-[#e8112d]/40 px-6 py-5 flex items-center justify-between gap-4 transition-all duration-300 hover:-translate-y-0.5 group"
              >
                <div className="flex items-center gap-4">
                  <MapPin className="w-5 h-5 text-[#e8112d] shrink-0" />
                  <div>
                    <p className="text-sm sm:text-base font-semibold text-slate-100">{z.zone}</p>
                    <p className="font-tech text-[11px] uppercase tracking-[0.18em] text-slate-500 mt-1 flex items-center gap-1.5">
                      <Timer className="w-3.5 h-3.5" /> {z.time}
                    </p>
                  </div>
                </div>
                <span
                  className={`font-tech text-[10px] uppercase tracking-[0.18em] px-3 py-1.5 rounded-full border ${
                    z.hot
                      ? "border-[#25D366]/40 text-[#25D366] bg-[#25D366]/10"
                      : "border-white/10 text-slate-400 bg-white/5"
                  }`}
                >
                  {z.status}
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 mt-16">
        <Reveal>
          <div
            data-testid="coverage-map"
            className="rounded-2xl overflow-hidden border border-white/10 shadow-2xl shadow-black/60 h-[380px] sm:h-[440px]"
          >
            <MapContainer
              center={[-27.01, -48.64]}
              zoom={11}
              scrollWheelZoom={false}
              className="h-full w-full"
              style={{ background: "#090a0c" }}
            >
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              {zones.map((z) => (
                <CircleMarker
                  key={z.zone}
                  center={cityCoords[z.zone]}
                  radius={z.hot ? 14 : 10}
                  pathOptions={{
                    color: "#e8112d",
                    fillColor: "#e8112d",
                    fillOpacity: z.hot ? 0.55 : 0.35,
                    weight: 2,
                  }}
                >
                  <Popup>
                    <strong>{z.zone}</strong>
                    <br />
                    Chegada média: {z.time}
                  </Popup>
                </CircleMarker>
              ))}
            </MapContainer>
          </div>
          <p className="mt-4 text-center font-tech text-[11px] uppercase tracking-[0.2em] text-slate-500">
            Toque nos pontos vermelhos para ver o tempo de chegada por cidade
          </p>
        </Reveal>
      </div>
    </section>
  );
}
